import {lazy} from "react";

export const TasksTemplateSingleVoyagesLazy = lazy(() => import('./TasksTemplateSingleVoyages'))
